import React, { Suspense } from 'react'
import { Link } from 'react-router'

import { ROUTES } from '../../../constants/routes'
import { cn } from '../../../lib/helpers/miscHelpers'
import { BannerNotificationType } from '../../../types/enums'
import { useBannerNotificationQuery } from './useBannerNotificationQuery'

const BannerNotificationContent: React.FC = () => {
  const banner = useBannerNotificationQuery().data

  if (!banner) {
    return null
  }

  function getBannerClassName() {
    switch (banner?.type) {
      case BannerNotificationType.FREE_PLAN_USAGE_EXCEEDED:
        return 'bg-danger'
      default:
        return 'bg-primary'
    }
  }

  function renderBannerCta() {
    switch (banner?.type) {
      case BannerNotificationType.FREE_PLAN_USAGE_EXCEEDED:
        return (
          <Link
            to={ROUTES.account()}
            className="btn btn-primary btn-fluid flex-shrink-0"
          >
            Upgrade now
          </Link>
        )
      default:
        return null
    }
  }

  return (
    <div
      className={cn(
        'd-flex flex-wrap align-items-center justify-content-center gap-2 p-3 text-white',
        getBannerClassName(),
      )}
    >
      {banner.content}
      {renderBannerCta()}
    </div>
  )
}

const BannerNotification: React.FC = () => (
  <Suspense fallback={null}>
    <BannerNotificationContent />
  </Suspense>
)

export default BannerNotification
